module.exports = __webpack_public_path__ + "static/img/center_logo.7d443f3b.png";